import LinkBlockArrowShort from './LinkBlockArrowShort'

export default LinkBlockArrowShort
